"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPmiScheme = exports.getSchemeUrl = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var is_server_1 = tslib_1.__importDefault(require("../../_util/is-server"));
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
/**
* 1. 默认普通入会链接
* 2. 特邀二维码入会链接
* 3. 直接打开app链接
* @param {EnumLaunchType} type
* @param {string} meetingCode
* @param {string} joinToken 入会token
* @param {string} wtoken webinar专用token
*/
var getSchemeUrl = function (type, meetingCode, joinToken, wtoken, launchMode, meetingType, launchId, meetingId) {
    if (joinToken === void 0) { joinToken = ''; }
    var schemeUrl = "".concat(enum_1.EnumSchemeUrl.Inmeeting, "?meeting_code=").concat(meetingCode, "&token=").concat(joinToken, "&launch_id=").concat(launchId);
    if (
    // 私有化: 国家电网需要增加 tmid 参数
    process.env.WEMEET_PARAM_PRIVATE === 'state-grid') {
        schemeUrl += "&tmid=".concat(meetingCode);
    }
    if ((0, web_base_1.getRequest)('user_code')) {
        schemeUrl += "&user_code=".concat((0, web_base_1.getRequest)('user_code'));
    }
    // webinar报名页需要增加uid
    if (!is_server_1.default && window.webinarSchemeUserInfoParams) {
        schemeUrl += window.webinarSchemeUserInfoParams;
    }
    // 添加meeting_type_flags参数
    if (!is_server_1.default && window.schemeMeetingTypeFlagsParams) {
        schemeUrl += window.schemeMeetingTypeFlagsParams;
    }
    if (type === enum_1.EnumLaunchType.MeetingCode) {
        if (meetingType === enum_1.EnumMeetingType.SpeciallyInvitedMeeting
            && launchMode === enum_1.EnumLaunchMode.QrCode) {
            var obj_1 = {
                meeting_code: meetingCode,
                token: joinToken,
                launch_id: launchId,
                meeting_id: meetingId,
            };
            var str_1 = [];
            Object.keys(obj_1).forEach(function (prop) {
                str_1.push("".concat(prop, "=").concat(obj_1[prop]));
            });
            var queryString = str_1.join('&');
            schemeUrl = "wemeet2://page/invite/wechat?".concat(queryString);
        }
    }
    if (type === enum_1.EnumLaunchType.LaunchApp) {
        schemeUrl = "".concat(enum_1.EnumSchemeUrl.Launch, "?launch_id=").concat(launchId);
    }
    if (wtoken) {
        schemeUrl = (0, web_base_1.addURLSearch)(schemeUrl, {
            webinar_token: wtoken,
        });
    }
    if ((0, web_base_1.getRequest)('rs')) {
        schemeUrl = (0, web_base_1.addURLSearch)(schemeUrl, {
            rs: (0, web_base_1.getRequest)('rs'),
        });
    }
    init_aegis_1.default.logAll("[met-component-launchapp]getSchemeUrl ".concat(schemeUrl));
    return schemeUrl;
};
exports.getSchemeUrl = getSchemeUrl;
/**
 * pmi入会scheme
 * @param type
 * @returns
 */
var getPmiScheme = function (type, meetingCode) {
    var launchId = (0, web_base_1.randomString)(16);
    var schemeUrl = "".concat(enum_1.EnumSchemeUrl.Inmeeting, "?meeting_code=").concat(meetingCode, "&launch_id=").concat(launchId, "&is_pmi=1");
    if (type === enum_1.EnumLaunchType.LaunchApp) {
        schemeUrl = "".concat(enum_1.EnumSchemeUrl.Launch, "?launch_id=").concat(launchId);
    }
    return schemeUrl;
};
exports.getPmiScheme = getPmiScheme;
//# sourceMappingURL=get-scheme.js.map